export const noop = _ => _;

export const isExternal = (path) => /^(https?:|mailto:|tel:)/.test(path)

export const query2map = (url) => {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(`{"${decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`)
}

export const delay = (fn, timer = 0, ...args) => setTimeout(fn, timer, ...args)

export const formatDate = (date) => {

  const normalized = new Date(date);

  const yyyy = normalized.getFullYear();
  const mm = normalized.getMonth() + 1;
  const dd = normalized.getDate();

  const pad = (d) => d < 10 ? `0${d}` : d;

  return `${yyyy}/${pad(mm)}/${pad(dd)}`;
}

export const uuid = () => {
  let d = new Date().getTime();
  // eslint-disable-next-line
  const _uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line
    return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
  });
  return _uuid;
};

export const deepCopy = (target) => JSON.parse(JSON.stringify(target));
